import { render } from "./BulkReplace.vue?vue&type=template&id=7281d844&scoped=true"
import script from "./BulkReplace.vue?vue&type=script&lang=js"
export * from "./BulkReplace.vue?vue&type=script&lang=js"

import "./BulkReplace.vue?vue&type=style&index=0&id=7281d844&scoped=true&lang=css"

import exportComponent from "/home/user/docker/vpn/odessa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7281d844"]])

export default __exports__